import { createRecipe } from './runtime.js';

const publicFocusRingSidesConfig = {"name":"publicFocusRingSides","className":"focus-ring-sides"}

export const publicFocusRingSides = /* @__PURE__ */ createRecipe(publicFocusRingSidesConfig)